import React from 'react'
import OrphanRow from './OrphanRow'
import List from 'live/components/ui/List'
import { Table, HeadRow } from './styles'
import styled from 'styled-components'

type OrphanListProps = {
    orphans: Orphan[]
    fetchOrphans: (pageNumber: number, search: string) => void
}

const OrphanList: React.FC<OrphanListProps> = ({ orphans, fetchOrphans }: OrphanListProps) => {
    return (
        <>
            {orphans.length > 0 ? (
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                <List
                    sort={false}
                    search={false}
                    filter={false}
                    items={orphans}
                    render={(items: Orphan[]) => {
                        // eslint-disable-next-line react/jsx-key
                        return (
                            <Table>
                                <HeadRow>
                                    <div>Info</div>
                                    <div>Orphan Wellbore</div>
                                    <div>Renamed To</div>
                                    <div>Event Type</div>
                                    <div>Data Size</div>
                                    <div>View</div>
                                    <div>Delete</div>
                                    <div>Updated By</div>
                                </HeadRow>
                                {items.map(item => (
                                    <OrphanRow key={item.id} orphan={item} fetchOrphans={fetchOrphans} />
                                ))}
                            </Table>
                        )
                    }}
                />
            ) : (
                <NoData>No orphans found</NoData>
            )}
        </>
    )
}

export default OrphanList

const NoData = styled.div`
    color: #999;
    font-size: 18px;
    text-align: center;
    margin-top: 20px;
`
